export default __webpack_public_path__ + "static/media/skyward_blade.af22a740.png";